import { useCallback, useRef, createRef } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';

import { appStore } from '../../managers/globalState';
import globalRefs from '../../managers/globalRefs';

import Overlay from '../overlays';
import GridList from '../grid_list';
import { NISAR_ITEMS } from '../../data/nisar';

import LayerGroupSolidSVG from '../../../www/assets/images/layer_group_solid.svg';

import '../../../www/assets/css/overlays/dem.css';
import ar from '../../languages/ar';

const TITLE_TEXT = ar.nisar_images;
const THUMB_WIDTH = 159;
const THUMB_HEIGHT = 102;
const ITEM_PADDING = 30;
const NISAR_THUMBNAILS = NISAR_ITEMS.map(({ external_id, list_image_src, title }) => ({
	id: external_id,
	thumbSrc: list_image_src,
	title
}));

const NisarItem = ({ title, thumbSrc, id, onItemClick }) => {
	const containerStyle = {
		width: `${THUMB_WIDTH}px`,
		height: `${THUMB_HEIGHT}px`
	};

	return (
		<figure className='dem-item' onClick={() => onItemClick(id)}>
			<div className='image-time-container dem-image-container' style={containerStyle}>
				{thumbSrc ? <img className='thumbnail dem-thumbnail' src={thumbSrc} alt={title} /> : <div className='dem-thumbnail placeholder' />}
			</div>
			<figcaption className='dem-title'>{title}</figcaption>
		</figure>
	);
};

const NisarOverlay = ({ closeOverlay }) => {
	const mainRef = useRef();
	const scrollableNodeRef = createRef();
	const { isWindows } = useSnapshot(appStore.state);

	const navToNisarImage = useCallback(imageId => {
		closeOverlay(true);
		const { getManager } = globalRefs;
		getManager('route').navigateToNisar(imageId);
	}, [closeOverlay]);

	const overlayComponents = (
		<>
			<Overlay.Header
				back
				onClose={closeOverlay}
				title={TITLE_TEXT}
				Icon={LayerGroupSolidSVG}
			/>
			{NISAR_THUMBNAILS?.length
				? (
					<div className='content-mask'>
						<GridList
							rowClassName='flex-grid-row'
							minPerRow={2}
							dataList={NISAR_THUMBNAILS}
							itemSize={THUMB_WIDTH + ITEM_PADDING * 2}
							itemPadding={[ITEM_PADDING, ITEM_PADDING]}
							itemComponent={<NisarItem onItemClick={navToNisarImage} />}
							scrollableRef={isWindows ? scrollableNodeRef : mainRef}
						/>
					</div>
				)
				: <Overlay.NoResults />}
		</>
	);

	return (
		<Overlay type='nisar' ref={mainRef}>
			{isWindows
				? (
					<SimpleBar scrollableNodeProps={{ ref: scrollableNodeRef }} style={{ height: '100%' }}>
						{overlayComponents}
					</SimpleBar>
				)
				: overlayComponents}
		</Overlay>
	);
};

NisarOverlay.propTypes = {
	closeOverlay: PropTypes.func.isRequired
};

export default NisarOverlay;
